import React, { useState } from "react";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../../../Firebase/Firebase";
// import CertificationData from '../../../data/CertificationsData'
import { JsonEditor as Editor } from "jsoneditor-react";
import "jsoneditor-react/es/editor.min.css";

function CertificationsEdit(props) {
  const CertificationsData = props;
  // const data = CertificationData;
  //   async function UploadData() {
  //   // Add a new document with a generated id.
  //   const docRef =  setDoc(doc(db, "Elemento", "Certifications" ), data);
  //   console.log("Document written with ID: ", docRef.id);
  // }

  const [EditorData, setEditorData] = useState(
    CertificationsData.CertificationsData
  );
  function handleChange(EditorData) {
    let check = document.getElementById("WebsitePreview");
    check.contentWindow.parentFrame = 0;
    const CertificationsData = EditorData.CertificationsData;
    check.contentWindow.postMessage({ CertificationsData });
    setEditorData(CertificationsData);
  }
  async function Save() {
    console.log("saving here");
    console.log(EditorData);
    const docRef = setDoc(doc(db, "Elemento", "Certifications"), EditorData);
    console.log("Document written with ID: ", docRef.id);
  }
  return (
    <div>
      <h1>AboutMe Info Edit Page</h1>
      {CertificationsData.CertificationsData && (
        <div>
          <Editor
            value={CertificationsData}
            onChange={handleChange}
            history={true}
            allowedModes={["tree", "code"]}
          />
        </div>
      )}

      <div className="d-flex justify-content-end">
        <button className="btn btn-success mt-1" onClick={Save}>
          Save
        </button>
      </div>
      {/* <button onClick={UploadData}>Upload Data</button> */}
    </div>
  );
}

export default CertificationsEdit;
